import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PatientCaseEndoFinalReportDataModel} from '../models/finalReport/patient-case-endo-final-report-data.model';
import {FinalReportInfoDto} from '../models/accountsReceivable/data-patient-case.model';
import {ReportConfigurationModel} from '../models/configuration/report-configuration.model';
import {PatientCaseEndoFinalReportNoteModel} from '../models/finalReport/patient-case-endo-final-report-note.model';

@Injectable({
  providedIn: 'root'
})
export class FinalReportService {

  constructor(private readonly http: HttpClient) {

  }

  getCaseInfo(patientCaseId: string, CaseWorkItemFormsId: string) {
    return this.http.get<FinalReportInfoDto>(`api/final-report/get-patient-case/${patientCaseId}/${CaseWorkItemFormsId}`);
  }

  getFinalReport(patientCaseId: string) {
    return this.http.get<PatientCaseEndoFinalReportDataModel>(`api/final-report/get-final-report/${patientCaseId}`);
  }

  getFinalReportsForPatient(patientId: string) {
    return this.http.get<PatientCaseEndoFinalReportNoteModel[]>(`api/final-report/get-final-reports-for-patient/${patientId}`);
  }

  getFinalReportFromPatientSubCase(patientCaseId: string) {
    return this.http.get<PatientCaseEndoFinalReportDataModel>(`api/final-report/get-final-report-from-patient-subcase/${patientCaseId}`);
  }

  saveFinalReport(model: PatientCaseEndoFinalReportDataModel) {
    return this.http.post<PatientCaseEndoFinalReportDataModel>('api/final-report/save-final-report', model);
  }

  getReports() {
    return this.http.get<ReportConfigurationModel[]>(`api/final-report/get-reports`);
  }

  sendFinalReport(LOCID: number,  PatientId: string, EnterpriseID: number,  referralEmail: string, referralDoctorContactId: string,model: PatientCaseEndoFinalReportDataModel) {
   let url = '';
    if(referralEmail === null || referralEmail === undefined || referralEmail === ''){
     url = `api/final-report/send-final-report/${LOCID}/${PatientId}/${EnterpriseID}`;
    }else{
     url = `api/final-report/send-final-report/${LOCID}/${PatientId}/${EnterpriseID}/${referralEmail}/${referralDoctorContactId}`;
  }
    return this.http.post<void>(url, model);
  }
}
